import React, { useState } from 'react';
import LoadingBackdrop from '../commonUI/LoadingBackdrop';
import Dialog from '@mui/material/Dialog';
import Fade from '@mui/material/Fade';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const createSteps = {
  CONFIRM: 'CONFIRM',
  CREATING: 'CREATING',
  CREATE_COMPLETE: 'CREATE_COMPLETE',
};

function ConfirmCreateDialog(props) {
  const {
    open,
    handleClose,
    confirmTitle,
    confirmMessage,
    createCompleteTitle,
    createCompleteBtnLabel,
    createCompleteAction,

    createAction,
    handleDeleteSuccess,
    handleDeleteError,
  } = props;

  const [showStep, setShowStep] = useState(createSteps.CONFIRM);
  const [createdData, setCreatedData] = useState(null);

  const executeAction = async () => {
    setShowStep(createSteps.CREATING);

    try {
      const res = await createAction();
      setCreatedData(res.data);
      if (handleDeleteSuccess) handleDeleteSuccess(res);

      setShowStep(createSteps.CREATE_COMPLETE);
    } catch (error) {
      if (handleDeleteError) handleDeleteError(error);

      setShowStep(createSteps.CONFIRM);
    }
  };

  const handleConfirm = () => {
    executeAction();
  };

  const handleBack = () => {
    handleClose();
  };

  return (
    <>
      <Dialog
        maxWidth="sm"
        open={open}
        onClose={() => {
          if (!createSteps.CREATE_COMPLETE) {
            handleClose();
          }
        }}
        aria-labelledby="responsive-dialog-title"
        classes={{ root: 'bg-transparent' }}
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            paddingTop: '40px',
          },
        }}
        TransitionComponent={Fade}
      >
        <div className="w-full flex flex-col items-center pt-16 pb-8 px-8 bg-white rounded-3xl relative min-w-[360px]">
          {showStep === createSteps.CREATE_COMPLETE ? (
            <div className="absolute w-20 h-20 -top-10 left-1/2 -translate-x-1/2 rounded-full overflow-hidden bg-green-500 flex items-center justify-center">
              <FontAwesomeIcon icon={faCheck} size="3x" color="white" />
            </div>
          ) : null}

          {showStep === createSteps.CREATE_COMPLETE ? (
            <>
              <h3 className="text-xl font-semibold mb-14">{createCompleteTitle}</h3>

              <div className="w-full flex items-center justify-center text-white text-base font-semibold gap-8">
                <button
                  onClick={() => createCompleteAction(createdData)}
                  type="button"
                  className="button-size bg-gray-btn-secondary"
                >
                  {createCompleteBtnLabel}
                </button>
              </div>
            </>
          ) : (
            <>
              <h3 className="text-xl font-semibold mb-3">{confirmTitle}</h3>

              <p className="text-lg font-base mb-8">{confirmMessage}</p>

              <div className="w-full flex items-center justify-center text-white text-base font-semibold gap-8">
                <button onClick={handleBack} type="button" className="button-size bg-gray-btn-secondary">
                  {props.confirmCancleLabel || 'キャンセル'}
                </button>
                <button onClick={handleConfirm} type="button" className="button-size bg-blue-btn-primary">
                  {props.confirmLabel || '作成する'}
                </button>
              </div>
            </>
          )}
        </div>
      </Dialog>

      <LoadingBackdrop isOpen={showStep === createSteps.CREATING} />
    </>
  );
}

export default ConfirmCreateDialog;
